/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { LinkedFile } from './linkedFile';

export interface ProjectFileTableDTO { 
    id?: string;
    name?: string;
    size?: number;
    lastModified?: Date;
    lastModifiedBy?: string;
    created?: Date;
    createdBy?: string;
    contentType?: string;
    fileType?: ProjectFileTableDTO.FileTypeEnum;
    fragmentsCreated?: boolean;
    description?: string;
    fileStatus?: ProjectFileTableDTO.FileStatusEnum;
    errorReason?: string;
    classificationAttempts?: number;
    parentId?: string;
    sourceLinkId?: string;
    externalWebUrl?: string;
    documentClassTitles?: Array<string>;
    classificationRuleIds?: Array<string>;
    linkedFiles?: Array<LinkedFile>;
    isFolder?: boolean;
    sizeInMB?: number;
    analyseCompleted?: boolean;
    analyseFailed?: boolean;
    classificationExhausted?: boolean;
}
export namespace ProjectFileTableDTO {
    export type FileTypeEnum = 'FOLDER' | 'PDF' | 'IFC' | 'EXCEL' | 'POWERPOINT' | 'WORD' | 'UNKNOWN' | 'COORDINATION';
    export const FileTypeEnum = {
        FOLDER: 'FOLDER' as FileTypeEnum,
        PDF: 'PDF' as FileTypeEnum,
        IFC: 'IFC' as FileTypeEnum,
        EXCEL: 'EXCEL' as FileTypeEnum,
        POWERPOINT: 'POWERPOINT' as FileTypeEnum,
        WORD: 'WORD' as FileTypeEnum,
        UNKNOWN: 'UNKNOWN' as FileTypeEnum,
        COORDINATION: 'COORDINATION' as FileTypeEnum
    };
    export type FileStatusEnum = 'UPLOADING' | 'UPLOADED' | 'PROCESSING' | 'READY' | 'CHECKED' | 'ERROR';
    export const FileStatusEnum = {
        UPLOADING: 'UPLOADING' as FileStatusEnum,
        UPLOADED: 'UPLOADED' as FileStatusEnum,
        PROCESSING: 'PROCESSING' as FileStatusEnum,
        READY: 'READY' as FileStatusEnum,
        CHECKED: 'CHECKED' as FileStatusEnum,
        ERROR: 'ERROR' as FileStatusEnum
    };
}